import _isFunction from "lodash/isFunction";
var _excluded = ["isTouched", "error"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../Icon';
import { useInput } from './useInput';
import InputContainer from '../InputContainer';
import { inputField } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Input = function Input(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      required = props.required,
      validate = props.validate,
      label = props.label,
      placeholder = props.placeholder,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      inputRef = props.inputRef,
      hasErrorProp = props.hasError,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      small = props.small;
  var Component = type === 'textarea' ? 'textarea' : 'input';

  var _useInput = useInput(props),
      isTouched = _useInput.isTouched,
      error = _useInput.error,
      inputAttr = _objectWithoutProperties(_useInput, _excluded);

  var hasError = isTouched && !!error;
  var hasValidation = _isFunction(validate) || required;
  return ___EmotionJSX(InputContainer, _extends({}, props, {
    error: error,
    isTouched: isTouched
  }), leftIcon !== null && leftIcon !== void 0 && leftIcon.iconName ? ___EmotionJSX(Icon, _extends({
    position: "absolute",
    top: "".concat(label ? 3.25 : 1.25 - (small ? 0.45 : 0), "rem"),
    left: "1.2rem",
    color: "gray300",
    size: 18
  }, leftIcon)) : leftIcon, ___EmotionJSX(Component, _extends({
    ref: inputRef,
    type: type,
    className: "input",
    css: inputField(hasValidation, hasError || hasErrorProp, props),
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label ? "".concat(label, "...") : ''
  }, _isFunction(onFocus) && {
    onFocus: onFocus
  }, _isFunction(onKeyDown) && {
    onKeyDown: onKeyDown
  }, inputAttr)), rightIcon !== null && rightIcon !== void 0 && rightIcon.iconName ? ___EmotionJSX(Icon, rightIcon) : rightIcon);
};

Input.propTypes = {
  inputRef: PropTypes.object,
  label: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onError: PropTypes.func,
  placeholder: PropTypes.string,
  validate: PropTypes.func,
  pattern: PropTypes.func,
  horizontal: PropTypes.bool,
  className: PropTypes.string,
  formId: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  leftIcon: PropTypes.object,
  rightIcon: PropTypes.object,
  small: PropTypes.bool
};
var InputRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(Input, _extends({}, props, {
    componentRef: ref
  }));
});
InputRef.displayName = 'Input';
export default InputRef;